import { Route, Routes, useParams } from 'react-router-dom';

import { paths, routes } from 'data/routes';
import { useColumns } from 'data/tableData/catalogue/seasonsColumns';

import { Manage } from 'sections/Manage';

import { Table } from 'components/Table';

import * as S from '../../../Budget/components/List/List.styles';
import { manageCategoriesTabs } from './constants/constants';
import { useSeasons } from './useSeasons';

export function Seasons(): React.ReactElement {
  const seasonsColumns = useColumns();
  const params = Object.values(useParams());
  const hasNew = params.includes('new');
  const hasEdit = params.includes('edit');
  const { seasonTab, seasons } = useSeasons();

  return (
    <div>
      {!hasNew && !hasEdit && (
        <S.CreateWrapper>
          <S.Create
            fontFamily="LFT Zeno Condensed"
            iconLeft="FiPlus"
            scale="lg"
            asLink
            to={`${routes.seasons + routes.add}`}
            motive="addNew"
            textTransform="uppercase"
          >
            Add new season
          </S.Create>
        </S.CreateWrapper>
      )}
      <Routes>
        <Route
          index
          element={
            <Table columns={seasonsColumns} data={seasons} hasPagination autoResetPage />
          }
        />
        <Route
          path={paths.add}
          element={<Manage title="Add new season" tabs={seasonTab} />}
        />
        <Route
          path={paths.edit}
          element={<Manage title="Edit season" tabs={seasonTab} />}
        />
        <Route
          path={paths.manage}
          element={<Manage title="Categories" tabs={manageCategoriesTabs} />}
        />
      </Routes>
    </div>
  );
}
